import { homeConstants } from "../constants";

export default function (
  state = {
    event: "",
    page: "Home Page",
    campaign: "",
    medium: "",
    source: "web",
    term: "",
    device_id: "",
    screen: "Home",
    screen_title: "Global",
    user_id: "",
    session_id: "",
    screen_referrer: "",
    medication_name: "",
    insurance: "",
    insurance_type: "",
    coupon_provider: "",
    med_form: "",
    med_dosage: "",
    med_quantity: "",
    date_time: new Date().getTime(),
    zipcode: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.GET_GTM_DATA_LAYER:
      return {
        data: state,
      };
    case homeConstants.UPDATE_GTM_DATA_LAYER: {
      const result = Object.assign(state.data, action?.data);
      return {
        data: { ...result, date_time: new Date().getTime() },
      };
    }
    default:
      return state;
  }
}
